import React from 'react';
import { IcoMoonIcon } from '../../../../../packages/ui/components/icons';
import { cn } from '../../../../../packages/ui/lib/lib';

const RarityStars = ({ level, className = '' }) => {
  try {
    const [star = 0, rarity = 0] = level.split('_');
    return (
      <div className="flex items-center">
        {Array.from(Array(parseInt(rarity)).keys()).map((i) => (
          <IcoMoonIcon
            key={i}
            iconName="star-fill"
            className={cn('size-4', className)}
          />
        ))}
        {Array.from(Array(parseInt((star - rarity).toString())).keys()).map(
          (i) => (
            <IcoMoonIcon
              key={i}
              iconName="star-empty"
              className={cn('size-4', className)}
            />
          )
        )}
      </div>
    );
  } catch {
    return null;
  }
};

export default RarityStars;
